<template>
  <div id="parentx">
    <vs-sidebar
      class="relative"
      parent="body"
      default-index="1"
      color="primary"
      spacer
      position-right
      v-model="isWidgetCard"
      style="z-index: 500000"
    >
      <vs-row class="px-6 my-6">
        <div class="w-full flex items-center justify-between">
          <h3 class="font-semibold mb-1">Add Gadgets</h3>
          <vs-icon
            class="text-2xl cursor-pointer"
            color="#798BA0"
            icon="icon-x"
            icon-pack="feather"
            @click.native="closeWidgetLibrary"
          />
        </div>
        <h5 class="my-3">
          Gadgets allow you to view the summary of an app. Add Gadgets for your
          dashboard to have a quick view of your activity.
        </h5>
        <vs-row>
          <!-- organization dropdown  -->
          <!-- <vs-select
            class="w-full"
            placeholder="Organization"
            v-model="organization"
          >
            <vs-select-item
              v-for="(type, index) in types"
              :key="index"
              :value="type.value"
              :text="type.text"
            />
          </vs-select> -->
          <!--// organization dropdown  --></vs-row
        >
      </vs-row>
      <vs-sidebar-item
        v-for="(widget, index) in widgetsArray"
        :key="index"
        :index="index + 1"
      >
        <vx-card class="widget__card__border"
          ><vs-row class="justify-between"
            ><vs-col class="flex flex-col justify-between w-1/5">
              <div class="h-16 p-2 widget__card__border mb-2">
                <img
                  class="w-full h-full"
                  :src="widget.icon"
                  :alt="widget.name"
                />
              </div>

              <div
                v-if="
                  (isDevelopmentCharter &&
                    widget.id === 'DEVELOPMENT_CHARTER') ||
                  (isQueueCard && widget.id === 'ACTIVITY_QUEUE') ||
                  (isTalentCard && widget.id === 'TALENT_CARD') ||
                  (isProfileCard && widget.id === 'PROFILE_CARD') ||
                  (isQuestCard && widget.id === 'ACTIVE_QUEST') ||
                  (isUserWallet && widget.id === 'USER_WALLET')
                "
                class="px-4 py-2 rounded-md add-btn cursor-pointer text-center"
                @click="removeWidget(widget.id)"
              >
                Remove
              </div>
              <div
                v-else
                class="px-6 py-2 rounded-md add-btn cursor-pointer text-center"
                @click="addWidget(widget.id)"
              >
                Add
              </div>
            </vs-col>
            <vs-col class="w-9/12">
              <h4 class="font-semibold mb-1">{{ widget.name }}</h4>
              <h5>
                {{ widget.description }}
              </h5>
            </vs-col>
          </vs-row>
        </vx-card>
      </vs-sidebar-item>
    </vs-sidebar>
  </div>
</template>

<script>
import widgets from "@/assets/data/widget.js";
export default {
  data: () => ({
    // organization: "",
    types: [],
    widgets,
    widgetsArray: [],
  }),
  computed: {
    isWidgetCard: {
      get() {
        return this.$store.state.dashboard.isWidgetCard;
      },
      set(newVal) {
        return newVal;
      },
    },
    userOrganizations() {
      return this.$store.state.users.userOrganizations;
    },
    userData() {
      return this.$store.state.users.data;
    },
    isDevelopmentCharter() {
      return this.$store.state.dashboard.isDevelopmentCharter;
    },
    isQueueCard() {
      return this.$store.state.dashboard.isQueueCard;
    },
    isTalentCard() {
      return this.$store.state.dashboard.isTalentCard;
    },
    userWidgets() {
      return this.$store.state.dashboard.userWidgets;
    },
    isQuestCard() {
      return this.$store.state.dashboard.isQuestCard;
    },
    isProfileCard() {
      return this.$store.state.dashboard.isProfileCard;
    },
    isUserWallet() {
      return this.$store.state.dashboard.isUserWallet;
    },
    appSubscriptions() {
      return this.$store.state.users.appSubscriptions;
    },
  },
  watch: {
    userWidgets: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          if (
            this.appSubscriptions &&
            typeof this.appSubscriptions["coach"] !== "undefined"
          ) {
            this.widgetsArray = this.widgets;
          } else {
            var filteredArray = this.widgets.filter(function (itm) {
              return itm.widgetId !== "ACTIVE_QUEST";
            });
            this.widgetsArray = filteredArray;
          }
          for (let i = 0; i <= newVal.length; i++) {
            if (
              newVal[i] &&
              newVal[i].widgetId &&
              newVal[i].status === "ACTIVE"
            ) {
              if (newVal[i].widgetId === "DEVELOPMENT_CHARTER") {
                this.$store.commit("dashboard/SHOW_DEVELOPMENT_CHARTER", true);
              }
              if (newVal[i].widgetId === "ACTIVITY_QUEUE") {
                this.$store.commit("dashboard/SHOW_QUEUE_CARD", true);
              }

              if (newVal[i].widgetId === "TALENT_CARD") {
                this.$store.commit("dashboard/SHOW_TALENT_CARD", true);
              }
              if (newVal[i].widgetId === "PROFILE_CARD") {
                this.$store.commit("dashboard/SHOW_PROFILE_CARD", true);
              }

              if (newVal[i].widgetId === "ACTIVE_QUEST") {
                this.$store.commit("dashboard/SHOW_QUEST_CARD", true);
              }

              if (newVal[i].widgetId === "USER_WALLET") {
                this.$store.commit("dashboard/SHOW_USER_WALLET", true);
              }
            }
          }
        }
      },
    },
    isWidgetCard(newVal) {
      if (newVal && newVal === true) {
        document.body.className += "overflow-hidden";
      } else {
        document.body.classList.remove("overflow-hidden");
      }
    },
  },
  methods: {
    closeWidgetLibrary() {
      this.$store.commit("dashboard/SHOW_WIDGETS_CARD", false);
    },
    addWidget(widgetId) {
      const widget = {
        userId: this.userData._id,
        organizationId: this.organization,
        widgetId: widgetId,
      };
      this.$store
        .dispatch("dashboard/addWidget", widget)
        .then((res) => {
          if (res) {
            this.$store.commit("dashboard/ADD_WIDGET", widget);
            if (widgetId === "DEVELOPMENT_CHARTER") {
              this.$store.commit("dashboard/SHOW_DEVELOPMENT_CHARTER", true);
            }
            if (widgetId === "ACTIVITY_QUEUE") {
              this.$store.commit("dashboard/SHOW_QUEUE_CARD", true);
            }

            if (widgetId === "TALENT_CARD") {
              this.$store.commit("dashboard/SHOW_TALENT_CARD", true);
            }

            if (widgetId === "PROFILE_CARD") {
              this.$store.commit("dashboard/SHOW_PROFILE_CARD", true);
            }

            if (widgetId === "ACTIVE_QUEST") {
              this.$store.commit("dashboard/SHOW_QUEST_CARD", true);
            }

            if (widgetId === "USER_WALLET") {
              this.$store.commit("dashboard/SHOW_USER_WALLET", true);
            }
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    getOrganizations() {
      for (let i = 0; i < this.userOrganizations.length; i++) {
        let obj = {};
        obj["text"] = this.userOrganizations[i].organizationData.name;
        obj["value"] = this.userOrganizations[i].organizationId;
        this.types.push(obj);
        this.organization = this.types[0].value;
      }
    },
    removeWidget(widgetId) {
      this.$store
        .dispatch("dashboard/removeWidget", {
          userId: this.userData._id,
          widgetId: widgetId,
        })
        .then((res) => {
          if (res) {
            for (var i = 0; i < this.userWidgets.length; i++) {
              if (this.userWidgets[i].widgetId === widgetId) {
                this.$store.commit("dashboard/REMOVE_WIDGET", i);

                if (widgetId === "DEVELOPMENT_CHARTER") {
                  this.$store.commit(
                    "dashboard/SHOW_DEVELOPMENT_CHARTER",
                    false
                  );
                }
                if (widgetId === "ACTIVITY_QUEUE") {
                  this.$store.commit("dashboard/SHOW_QUEUE_CARD", false);
                }

                if (widgetId === "TALENT_CARD") {
                  this.$store.commit("dashboard/SHOW_TALENT_CARD", false);
                }

                if (widgetId === "PROFILE_CARD") {
                  this.$store.commit("dashboard/SHOW_PROFILE_CARD", false);
                }

                if (widgetId === "ACTIVE_QUEST") {
                  this.$store.commit("dashboard/SHOW_QUEST_CARD", false);
                }

                if (widgetId === "USER_WALLET") {
                  this.$store.commit("dashboard/SHOW_USER_WALLET", false);
                }
              }
            }
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },
  mounted() {
    this.getOrganizations();
  },
};
</script>

<style lang="scss" scoped>
$bg: #fba62742;
$color: #fba727;
.vs-content-sidebar ::v-deep.vs-sidebar--background,
.vs-content-sidebar ::v-deep.vs-sidebar {
  z-index: 100000;
}

.vs-content-sidebar ::v-deep {
  .vs-sidebar--background,
  .vs-content-sidebar ::v-deep.vs-sidebar {
    z-index: 100000;
  }
}

.vs-content-sidebar ::v-deep.vs-sidebar--items {
  overflow-y: scroll;
}

.widget {
  &__card {
    &__border {
      border: 2px solid #dfe4f0;
      border-radius: 12px;
    }
  }
}

.vs-content-sidebar ::v-deep.vs-sidebar {
  max-width: 450px;
}

.vs-content-sidebar ::v-deep.vs-sidebar-item-active {
  border: none !important;
}

.vs-sidebar--item ::v-deep i.material-icons {
  color: #626262 !important;
  font-size: 1.5em;
}

.con-select::v-deep .vs-select--input {
  color: #626262 !important;
}
.add-btn {
  color: #fff;
  background: $color;
  border-radius: 6px;
}
</style>
